// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.footer {
    min-height: 150px;
    border-top: 2px solid #F2F2F2 ;
    padding-top: 30px;
   
 }
 
 @media screen and (min-width: 600px) {
   .footer {
   
    margin-right: 10em;
   margin-left: 10em; 
 }
 }
 
 .footer-span {
     padding-right: 0.5rem !important;
     padding-left: 0.5rem;
     border-right: 2px solid #F2F2F2 ;
    
 
 }

 .footer-org-chart a {
   padding-right: 0.5rem !important;
   padding-left: 0.5rem;
   border-right: 2px solid #F2F2F2 ;
   text-decoration: none;
   color: #116AAB;
   font-weight: 350;
   font-size: 0.9rem;
  

}



#dropdown-button-drop-up {
   padding-top: 0px;
   padding-bottom: 9px;
}
 
 .footer-span a {
   text-decoration: none;
   color: #116AAB;
   font-weight: 350;
   font-size: 0.9rem;
 
 }

 .footer-span-small a {
    text-decoration: none !important;
    color: #116AAB;
    font-weight: 350;
  
 }
 
 .footer-at-fao{
    margin-top: 2rem;
    /* margin-right: 20px;
    margin-left: 20px; */
    text-align: left;
    font-size: 0.9rem;
    color: rgb(74, 73, 73);
 }

 .title-category{
    font-weight: 700;
    text-transform: uppercase;
    font-size: 12px;
    color: #999999;
 }

 

`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;;CAEpB;;CAEA;GACE;;IAEC,kBAAkB;GACnB,iBAAiB;CACnB;CACA;;CAEA;KACI,gCAAgC;KAChC,oBAAoB;KACpB,gCAAgC;;;CAGpC;;CAEA;GACE,gCAAgC;GAChC,oBAAoB;GACpB,gCAAgC;GAChC,qBAAqB;GACrB,cAAc;GACd,gBAAgB;GAChB,iBAAiB;;;AAGpB;;;;AAIA;GACG,gBAAgB;GAChB,mBAAmB;AACtB;;CAEC;GACE,qBAAqB;GACrB,cAAc;GACd,gBAAgB;GAChB,iBAAiB;;CAEnB;;CAEA;IACG,gCAAgC;IAChC,cAAc;IACd,gBAAgB;;CAEnB;;CAEA;IACG,gBAAgB;IAChB;wBACoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;CACzB;;CAEA;IACG,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,cAAc;CACjB","sourcesContent":["\n.footer {\n    min-height: 150px;\n    border-top: 2px solid #F2F2F2 ;\n    padding-top: 30px;\n   \n }\n \n @media screen and (min-width: 600px) {\n   .footer {\n   \n    margin-right: 10em;\n   margin-left: 10em; \n }\n }\n \n .footer-span {\n     padding-right: 0.5rem !important;\n     padding-left: 0.5rem;\n     border-right: 2px solid #F2F2F2 ;\n    \n \n }\n\n .footer-org-chart a {\n   padding-right: 0.5rem !important;\n   padding-left: 0.5rem;\n   border-right: 2px solid #F2F2F2 ;\n   text-decoration: none;\n   color: #116AAB;\n   font-weight: 350;\n   font-size: 0.9rem;\n  \n\n}\n\n\n\n#dropdown-button-drop-up {\n   padding-top: 0px;\n   padding-bottom: 9px;\n}\n \n .footer-span a {\n   text-decoration: none;\n   color: #116AAB;\n   font-weight: 350;\n   font-size: 0.9rem;\n \n }\n\n .footer-span-small a {\n    text-decoration: none !important;\n    color: #116AAB;\n    font-weight: 350;\n  \n }\n \n .footer-at-fao{\n    margin-top: 2rem;\n    /* margin-right: 20px;\n    margin-left: 20px; */\n    text-align: left;\n    font-size: 0.9rem;\n    color: rgb(74, 73, 73);\n }\n\n .title-category{\n    font-weight: 700;\n    text-transform: uppercase;\n    font-size: 12px;\n    color: #999999;\n }\n\n \n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
